import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { F0Alert } from '@factorialco/f0-react'
import { UpdateTrainingMembershipDocument } from 'generated/resources/graphql'

import DayPicker from 'modules/core/components/DayPicker'
import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendToUI, i18nDateToString, dateUIToBackend } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  membershipId: string
  id: string
  completionDate: string
}
export const EditCompletionDateModal = ({ membershipId, id, completionDate }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [date, setDate] = useState<string>(
    completionDate ? dateBackendToUI(completionDate) : i18nDateToString(new Date(), 'ui')
  )
  const [updateTrainingMembership] = useMutation(UpdateTrainingMembershipDocument, {
    extractorFn: (data) => data.trainingsMutations.updateTrainingsTrainingMembership,
  })
  const onSubmit = async () => {
    if (date) {
      const result = await updateTrainingMembership({
        variables: {
          id: String(membershipId),
          trainingCompletedAt: dateUIToBackend(date),
        },
      })
      const handled = handleResult(result, () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('trainings.trainings_detail.training_details_updated'),
        })

        return
      })

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('trainings.trainings_detail.training_details_updated'),
        })
        navigate(
          navigation.trainings.list.details_revamp.view.participants.fullPath({ id: String(id) })
        )
      }
      return handled
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_detail.training_details_updated'),
      })
    }
  }
  return (
    <Modal
      title={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.update_completed_date_modal.title'
      )}
      illustration="document-edit"
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.participants.fullPath({ id: String(id) })
        )
      }
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button.Router
            to={{
              pathname: navigation.trainings.list.details_revamp.view.participants.fullPath({
                id: String(id),
              }),
            }}
            type="secondary"
          >
            {i18n.t('common.cancel')}
          </Button.Router>
          <Button onClick={onSubmit}>{i18n.t('common.submit')}</Button>
        </Box>
      }
    >
      <Box gap="s12">
        <F0Alert
          variant="info"
          title={i18n.t(
            'trainings.trainings_revamp.training_detail.employees_table.update_completed_date_modal.description'
          )}
          description=""
        />
        <DayPicker
          value={date}
          mode="single"
          label={i18n.t(
            'trainings.trainings_revamp.training_detail.employees_table.update_completed_date_modal.label'
          )}
          onChange={(value) => setDate(value)}
        />
      </Box>
    </Modal>
  )
}
